import Vue from 'vue'
import Vuex from 'vuex'
import { videoApi } from '@/api/video'
import { authApi } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: { siteName: 'Zwen 影视', themeColor: '#f04438' },
    navigation: [],
    banners: [],
    ads: [],
    sections: [],
    hotwords: [],
    loading: false,
    error: '',
    user: null,
    userError: ''
  },
  getters: {
    siteName: state => state.config.siteName || 'Zwen 影视'
  },
  mutations: {
    SET_HOME_LOADING (state, loading) { state.loading = loading },
    SET_HOME_ERROR (state, error) { state.error = error },
    SET_HOME (state, data) {
      state.config = data.config || state.config
      state.navigation = data.navigation || []
      state.banners = data.banners || []
      state.ads = data.ads || []
      state.sections = data.sections || []
      state.hotwords = data.hotwords || []
    },
    SET_USER (state, user) { state.user = user },
    SET_USER_ERROR (state, error) { state.userError = error }
  },
  actions: {
    loadHome ({ commit }) {
      commit('SET_HOME_LOADING', true)
      commit('SET_HOME_ERROR', '')
      return videoApi.home().then(data => {
        commit('SET_HOME', data || {})
      }).catch(error => {
        commit('SET_HOME_ERROR', error.message || '首页加载失败')
      }).then(() => {
        commit('SET_HOME_LOADING', false)
      })
    },
    loadUser ({ commit }, options) {
      const token = localStorage.getItem('zwen_token')
      commit('SET_USER_ERROR', '')
      if (!token) return Promise.resolve(null)
      return authApi.info().then(user => {
        if (localStorage.getItem('zwen_token') !== token) return null
        commit('SET_USER', user)
        return user
      }).catch(error => {
        if (error.code === 'AUTH_REQUIRED') {
          if (localStorage.getItem('zwen_token') === token) localStorage.removeItem('zwen_token')
          if (!localStorage.getItem('zwen_token')) commit('SET_USER', null)
        } else if (localStorage.getItem('zwen_token') === token) {
          commit('SET_USER_ERROR', '账号信息暂时加载失败，请重试')
        }
        if (options && options.strict) throw error
        return null
      })
    },
    login ({ dispatch }, payload) {
      return authApi.login(payload.username, payload.password).then(result => {
        localStorage.setItem('zwen_token', (result.tokenHead || 'Bearer ') + result.token)
        return dispatch('loadUser', { strict: true })
      })
    },
    logout ({ commit }) {
      return authApi.logout().catch(() => null).then(() => {
        localStorage.removeItem('zwen_token')
        commit('SET_USER', null)
        commit('SET_USER_ERROR', '')
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js